<template>
  <footer class="footer">
    <div class="d-flex flex-row flex-wrap">
      <div class="flex-grow-1">
        <p>
          &copy; {{ new Date().getFullYear() }} Copyright Sydney Markets
          Limited. &reg; Indicates Registered Trademark of Sydney Markets
          Limited
        </p>
        <p>
          <a
            href="https://www.sydneymarkets.com.au/privacy-policy.html"
            target="_blank"
            >Privacy Policy</a
          >
          ·
          <a
            href="https://www.sydneymarkets.com.au/copyright.html"
            target="_blank"
            >Terms &amp; Conditions</a
          >
          ·
          <a
            href="https://www.sydneymarkets.com.au/markets/buyers-pass-faq.html"
            target="_blank"
            >Buyer’s Pass FAQs</a
          >
        </p>
      </div>
      <div id="social-icons" class="h4">
        <p class="mb-2">Follow Us</p>
        <a
          v-for="(social, id) in socials"
          :key="id"
          :href="social.href"
          target="_blank"
        >
          <font-awesome-icon :icon="'fa-brands fa-' + social.faBrand" />
        </a>
      </div>
    </div>
    <div class="d-flex justify-content-center">
      <banner v-if="!hideAd" position="footer" />
    </div>
  </footer>
</template>
<script>
import Banner from "@/components/Banner.vue";

export default {
  components: { Banner },
  props: {
    hideAd: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      socials: [
        {
          faBrand: "facebook",
          href: "https://www.facebook.com/SydneyMarkets/"
        },
        {
          faBrand: "instagram",
          href: "https://www.instagram.com/sydneymarkets/"
        },
        {
          faBrand: "twitter",
          href: "https://www.twitter.com/sydneymarkets"
        },
        {
          faBrand: "youtube",
          href: "https://www.youtube.com/channel/UCJgch-D-tJdYxnP-tzty3Sw"
        }
      ]
    };
  }
};
</script>
<style scoped>
#social-icons svg {
  margin: 0 5px;
}

/* add a negative top-margin to the flex container */
footer > div {
  margin-top: -15px;
}

/* add a corresponding positive top margin to all flex items (all direct children of the flex container) */
footer > div > * {
  margin-top: 15px;
}

footer a {
  color: white !important;
  text-decoration: underline;
}
</style>
